import styled from 'styled-components';
import PlayImage from '../../../PlayImage/PlayImage';
import { playGrey10 } from '../../../design-tokens';

export const StyledHeroImage = styled(PlayImage)`
    position: relative;
    background: ${playGrey10};
`;
